import { render } from "./InSviluppoCard.vue?vue&type=template&id=da8cbdee&scoped=true"
import script from "./InSviluppoCard.vue?vue&type=script&lang=js"
export * from "./InSviluppoCard.vue?vue&type=script&lang=js"

import "./InSviluppoCard.vue?vue&type=style&index=0&id=da8cbdee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da8cbdee"]])

export default __exports__